
import { UblS3UploadedFile } from "@/plugins/ubl/models/ubl-archive-file";
import { UblService } from "@/plugins/ubl/services/ubl-service";
import { printLocalDate } from "@/utils/pretty-print";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			item: null as null | UblS3UploadedFile,
			dossierId: 0,
			userName: "",
			companyName: ""
		};
	},
	computed: {
		beginDate(): string {
			if (!this.item) return "";
			return printLocalDate(this.item.MinDate);
		},
		endDate(): string {
			if (!this.item) return "";
			return printLocalDate(this.item.MaxDate);
		}
	},
	methods: {
		async download() {
			console.log("ownload");
			if (!this.item) return;
			console.log("Downloading");
			await UblService.downloadArchiveFromPublicUrl(this.dossierId, this.item);
		}
	},
	async mounted() {
		let splashEl = document.getElementById("splash");
		if (!splashEl) return;
		splashEl.remove();

		this.dossierId = parseInt(this.$route.params.dossierId) || 0;
		let key = this.$route.params.key;
		let result = await UblService.getArchiveFromPublicUrl(this.dossierId, key);
		this.item = result.fileInfo;
		this.userName = result.userName;
		this.companyName = result.companyName;
	},
	i18nEx: {componentPrefix: "views.UblArchiveFromUrl"},
});
